// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__3xzL2","contact-link":"Privacy_contact-link__3NkSj","dates":"Privacy_dates__1cPix","watch-tac-btn":"Privacy_watch-tac-btn__1ozt2"};